import { reducerRegistry } from '../../../../reducerRegistry';

import listsReducersMap from './lists/reducersMap';

const combineMap = {
  lists: listsReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap(
    'promotionalMaterialsModule',
    combineMap
  );
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/promotionalMaterials/reducers/static/combineRegistry.js